import React from "react";
import Switch from "react-switch";
import styles from "./styles.module.scss";

interface SwitchToggleProps {
  checked: boolean;
  onChange: any;
  title: string;
  customText?: string;
  disabled?: boolean;
  'data-testid'?: string;
  small?: boolean;
}

const SwitchToggle = ({
  checked,
  onChange,
  title,
  customText = "",
  disabled = false,
  'data-testid': testId,
  small = false,
}: SwitchToggleProps) => {
  return (
    <div className={`${styles.switch_toggle} ${small ? styles.small : ''}`} data-testid={testId}>
      <div className={styles.container}>
        <Switch
          checked={checked}
          onChange={onChange}
          offColor="#CECECE"
          onColor="#27A4FF"
          onHandleColor="#FFFFFF"
          handleDiameter={small ? 20 : 25}
          uncheckedIcon={false}
          checkedIcon={false}
          height={small ? 24 : 30}
          width={small ? 40 : 50}
          className="react-switch"
          disabled={disabled}
        />
        <span className={styles.tag}>{title}</span>
        {customText !== "" && (
          <span className={styles.custom_text}>{customText}</span>
        )}
      </div>
    </div>
  );
};
export default SwitchToggle;
